import { z } from 'zod';
import { IsoDateTime, PageMeta, PageRequest, MutationReason } from './_common.js';
export const FraudFlagReason = z.enum([
    'ip_collision',
    'device_collision',
    'self_referral_suspect',
    'velocity_burst',
    'manual_flag',
]);
export const FraudReviewDecision = z.enum(['approve', 'reject', 'ban_device', 'ban_inviter']);
export const FraudInviteEntry = z.object({
    invite_id: z.number().int(),
    code: z.string(),
    inviter_id: z.string(),
    inviter_username: z.string(),
    claimed_by_user_id: z.string().nullable(),
    claimed_by_username: z.string().nullable(),
    ip_hash: z.string().nullable(),
    device_hash: z.string().nullable(),
    flag_reasons: z.array(FraudFlagReason),
    flag_details: z.record(z.unknown()),
    created_at: IsoDateTime,
    reviewed_at: IsoDateTime.nullable(),
    reviewed_by: z.string().nullable(),
    decision: FraudReviewDecision.nullable(),
});
export const FraudListRequest = PageRequest.extend({
    status: z.enum(['pending', 'reviewed', 'all']).default('pending'),
    flag_reason: FraudFlagReason.optional(),
    inviter_id: z.string().optional(),
    ts_after: IsoDateTime.optional(),
    ts_before: IsoDateTime.optional(),
});
export const FraudListResponse = z.object({
    items: z.array(FraudInviteEntry),
    page: PageMeta,
    pending_count: z.number().int(),
});
export const FraudReviewRequest = z.object({
    decision: FraudReviewDecision,
    reason: MutationReason,
});
export const FraudReviewResponse = z.object({
    invite_id: z.number().int(),
    decision: FraudReviewDecision,
    reviewed_at: IsoDateTime,
    inviter_payout_fired: z.boolean(),
    device_banned: z.boolean(),
    inviter_blocked: z.boolean(),
});
export const FraudBulkReviewRequest = z.object({
    invite_ids: z.array(z.number().int()).min(1).max(50),
    decision: FraudReviewDecision,
    reason: MutationReason,
});
export const FraudBulkReviewResponse = z.object({
    succeeded: z.array(z.number().int()),
    failed: z.array(z.object({ invite_id: z.number().int(), code: z.string(), message: z.string() })),
});
export const BannedDevice = z.object({
    device_hash: z.string(),
    banned_at: IsoDateTime,
    banned_by: z.string(),
    reason: z.string(),
    related_user_ids: z.array(z.string()),
});
export const BannedDeviceListRequest = PageRequest.extend({
    q: z.string().optional(),
});
export const BannedDeviceListResponse = z.object({
    items: z.array(BannedDevice),
    page: PageMeta,
});
export const BannedDeviceUnbanRequest = z.object({
    reason: MutationReason,
});
//# sourceMappingURL=fraud.js.map